import React, { useState } from 'react';
import addToMailchimp from 'gatsby-plugin-mailchimp';
import Loader from '../../admin/modal-overlays/loader';

const NewsLetter = () => {
  const [email, setEmail] = useState('');
  const [msg, setMsg] = useState('');
  const [loading, setLoading] = useState(false);

  const submitEmail = (e) => {
    e.preventDefault();
    setLoading(true);
    addToMailchimp(email)
      .then((data) => {
        if (data.result == 'error') {
          if (data.msg.search('is an invalid email address') >= 0) {
            setMsg('This email address is invalid');
          } else if (data.msg.search('is already subscribed') >= 0) {
            setMsg('This email address is already subscribed');
          } else {
            setMsg('An error occured while subscribing');
          }
          setLoading(false);
        } else {
          setEmail('');
          setMsg('Successfully Subscribed!');
          setLoading(false);
        }
      })
      .catch(() => {
        setLoading(false);
      });
  };

  return (
    <section className="our-subscription-section">
      <div className="container">
        <div className="banner-text-wrap">
          <h2 className="newsletter-h2">Our Newsletter</h2>
          <p className="newsletter-p">Subscribe to our newsletter to get periodic market updates and special offers.</p>
          <form className="newsletter-form">
            <input
              type="email"
              id="email"
              name="email"
              placeholder="Type your email"
              className="newsletter-form-input"
              onChange={(e) => setEmail(e.target.value)}
            />
            <button type="submit" className="newsletter-form-button" onClick={submitEmail}>
              Get the Reports
            </button>
          </form>
          <p className="mt-3">{msg}</p>
        </div>
      </div>
      <Loader isOpen={loading} />
    </section>
  );
};

export default NewsLetter;
